import { css } from '@lastbrand/web-ui-styled-system/css'

import { optionBoxRecipe } from './option-selector-shared.styles'

/**
 * DS twin of `packOption.module.scss`: square-cornered outlined chip, two stacked
 * lines (pack name + price, then per-item price).
 *
 * `@lastbrand/web-ui` `Button` takes styles via its `css` prop (a SystemStyleObject),
 * not `className`, so these are `css.raw` objects merged in the component. The chip
 * is display-only (no radio sibling) so it gets the box border from the shared
 * `optionBoxRecipe` base and darkens via the JS-merged `packSelectedCss`.
 *
 * `198px` width is off-grid (flagged: no-token).
 */
export const packButtonCss = css.raw(optionBoxRecipe.raw(), {
  textStyle: 'body-14',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  height: 'auto',
  minHeight: 'auto',
  borderRadius: 'radius-none',
  letterSpacing: 'normal',
  // 198px desktop / full mobile; px literal (no size token).
  width: { base: '100%', lg: '198px' },
  padding: '11px 0 7px',
})

export const packSelectedCss = optionBoxRecipe.raw({ selected: true })

export const packItemPriceClass = css({
  textStyle: 'body-12',
  color: 'mediumgray',
})
